import { render, staticRenderFns } from "./TransferItem.vue?vue&type=template&id=0226ae7e&scoped=true&"
import script from "./TransferItem.vue?vue&type=script&lang=js&"
export * from "./TransferItem.vue?vue&type=script&lang=js&"
import style0 from "./TransferItem.vue?vue&type=style&index=0&id=0226ae7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0226ae7e",
  null
  
)

export default component.exports